import {
  DASHBOARD_INTERNAL_TYPES,
  PM_PROVIDERS
} from 'common/constants/constants';

const ISSUE_TYPES_MAP = {
  [PM_PROVIDERS.JIRA]: {
    STORY: { id: 'story', name: 'Story' }
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    STORY: { id: 'User Story', name: 'User Story' }
  }
};

const formattedReports = reports => {
  return reports.map(report => {
    const updatedReport = { ...report };
    if (
      updatedReport?.definition?.filters?.selectedRepo &&
      updatedReport?.definition?.filters?.selectedRepo?.constructor?.name ===
        'Object'
    ) {
      const repoId = updatedReport.definition.filters.selectedRepo?.id;
      updatedReport.definition.filters.selectedRepo = repoId ? [repoId] : null;
    }

    if (
      updatedReport?.definition?.filters?.selectedService &&
      updatedReport?.definition?.filters?.selectedService?.constructor?.name ===
        'Object'
    ) {
      const serviceId = updatedReport.definition.filters.selectedService?.id;
      updatedReport.definition.filters.selectedService = serviceId
        ? [serviceId]
        : null;
    }

    return updatedReport;
  });
};

export const widgetFormatterByProvider = (dashboards, sensorId) => {
  const items = dashboards?.items || [];
  // Since repo and serivce used to be a single object
  // and now we are supporting multi,
  // we need to handle old behavior
  const boardsItems = formattedReports(items);

  const customPmMetrics = boardsItems.filter(
    ({ internal_type, auto_created }) =>
      internal_type === DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS &&
      auto_created
  )[0];
  const restOfDashboards = boardsItems.filter(
    ({ internal_type, auto_created }) =>
      internal_type !== DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS ||
      !auto_created
  );
  if (!sensorId || sensorId !== PM_PROVIDERS.AZURE_BOARDS || !customPmMetrics) {
    return dashboards;
  }
  const widgets = customPmMetrics?.definition?.widgets || [];
  const formattedWidgets =
    widgets?.map(widget => {
      const issueTypes = widget.filters?.issue_types || [];
      if (
        issueTypes[0]?.id === ISSUE_TYPES_MAP[PM_PROVIDERS.JIRA].STORY.id &&
        sensorId === PM_PROVIDERS.AZURE_BOARDS
      ) {
        return {
          ...widget,
          filters: {
            ...widget.filters,
            issue_types: [
              { ...ISSUE_TYPES_MAP[PM_PROVIDERS.AZURE_BOARDS].STORY }
            ]
          }
        };
      }
      return widget;
    }) || [];
  const formattedCustomPmMetrics = {
    ...customPmMetrics,
    definition: {
      ...customPmMetrics.definition,
      widgets: formattedWidgets
    }
  };

  return {
    ...dashboards,
    items: [...restOfDashboards, formattedCustomPmMetrics]
  };
};
